import { render } from "./Categories.vue?vue&type=template&id=e5181ccc&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=e5181ccc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5181ccc"

export default script